<template>
  <div>
    <v-alert
      prominent
      colored-border
      dismissible
      color="error"
      border="bottom"
      dense
      elevation="2"
      v-model="alert"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ message }}
        </v-col>
        <!-- <v-col class="shrink">
          <v-icon>mdi-content-copy</v-icon>
        </v-col> -->
      </v-row>
    </v-alert>
  </div>
</template>
<script>
export default {
  data() {
    return {
      alert: true,
    };
  },
  props: {
    message: {
      required: true,
    },
  },
};
</script>